/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Await_Dialog_DescriptionInputs */

const vi_await_dialog_description = /** @type {(inputs: Await_Dialog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Có ${i?.count} sản phẩm hiện chưa đủ tồn. Bạn muốn tạo đơn ở trạng thái "Chờ đóng gói" để đội đóng gói bổ sung, hay huỷ để chỉnh sửa số lượng?`)
};

/**

* @param {Await_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_dialog_description = /** @type {((inputs: Await_Dialog_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Dialog_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_dialog_description(inputs)
});